<template>
  <div>
    <right-panel id="sidebar-member-form" width="800px" @hidden="rightPanelClosed">
      <div class="p-3">
        <MemberForm />
      </div>
    </right-panel>

    <div class="card rounded">
      <div class="card-body">
        <div class="container-fluid ">
          <h2 class="mb-4">
            <letter-avatar :name="selectedOrganization.name" :image="selectedOrganization.logo" variant="secondary" />
            <span class="text-main ml-2"> {{ selectedOrganization.name }}</span>
            {{ $t("organization.members.text") }}
          </h2>

          <div class="d-flex justify-content-between w-100" style="margin-bottom: 1.70rem;">
            <div class="d-flex align-items-center w-50" style="gap: 2.34rem;"></div>
          </div>

          <b-row class="mb-2">
            <b-col>
              <div>
                <div class="search2">
                  <div class="search2--icon"><i class="iconoir-search"></i></div>
                  <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
                </div>
                <b-dropdown
                  v-if="pagination && pagination.docs.length > 0"
                  split
                  split-href="#"
                  :text="$t('task.download-options')"
                  size="sm"
                  variant="light"
                  class="m-2 text-right float-right"
                >
                  <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
                </b-dropdown>
              </div></b-col
            >
          </b-row>
          <content-loading v-if="isLoading" />
          <div v-if="pagination && pagination.docs.length > 0">
            <b-row v-for="item in pagination.docs" :key="item._id" class="border-top">
              <b-col md="4" class="member">
                <div class="member--img mt-1">
                  <letter-avatar :name="item.name" :image="item.avatar" variant="secondary"> </letter-avatar>
                </div>
                <div class="member--info mt-1">
                  <span v-if="item.isOwner" v-b-tooltip.hover :title="$t('organization.owner')" class="text-warning">
                    <i class="bx bxs-star"></i>
                  </span>
                  {{ item.name }}
                  <div class="member--mail">{{ item.email }}</div>
                </div>
              </b-col>

              <b-col md="5" class="pt-4">
                <div class="member--roles mt-2">
                  <div class="member--roles--tags">
                    <div v-for="role in item.roles" :key="item._id + role._id" class="mb-1">
                      <span class="badge badge-light border border-secondary p-1 ml-1">
                        {{ role.name | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </b-col>

              <b-col md="1" class="pt-4">
                <div class="">
                  <span v-if="!item.accessable" class="badge pill badge-soft-danger border border-danger">
                    {{ $t("organization.inaccessable") }}
                  </span>
                  <span v-else class="badge pill badge-soft-success border border-success">
                    {{ $t("organization.accessable") }}
                  </span>
                </div>
              </b-col>
              <!-- <b-col md="1" class="pt-4">
                <div>
                  <span v-if="!item.active" class="badge pill badge-soft-danger border border-danger" v-b-tooltip.hover :title="$t('common.contact-with-support')">
                    {{ $t("common.passive") }}
                  </span>
                  <span v-else class="badge pill badge-soft-success border border-success">
                    {{ $t("common.active") }}
                  </span>
                </div>
              </b-col> -->
              <b-col md="1" class="pt-4">
                <div>
                  <i class="bx bx-pencil hand" @click="edit(item)" v-b-toggle="'sidebar-member-form'"> </i>
                  <i class="bx bx-trash text-danger hand ml-2" @click="validate(item)" v-b-tooltip.hover :title="$t('common.delete')"></i>
                  <OrganizationMemberDeleteOptionModal :id="'organization-member-delete-option-modal' + item._id" :member="item" :strict="false" @remove="remove" />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <empty v-if="!isLoading && pagination && pagination.docs.length == 0">
          <h5 class="text-center">
            {{ $t("common.not-found") }}
          </h5>
        </empty>

        <div class="mt-4">
          <sweet-button class="mr-4" v-b-modal="'invite-member'" :loading="isUpdating" variant="link" icon="bx bx-plus" size="sm" buttonClass="mt-1 text-white btn-main">
            {{ $t("organization.invite") }}
          </sweet-button>

          <sweet-button v-b-modal="'import-members'" :loading="isUpdating" variant="link" icon="bx bx-plus" size="sm" buttonClass="mt-1 text-white btn-main">
            {{ $t("workspace.import-users") }}
          </sweet-button>
        </div>

        <modal id="invite-member" :title="$t('organization.invite')" size="xl" no-close-on-backdrop><!-- TKP-236 n.12: geniş; dışına tıklayınca kapanıp girilenler kaybolmaz --> <div class="px-md-5 mx-md-4 py-2" data-test="invite-body"><!-- TKP-240 b.5: alanlar kenara yapışmasın — solda ve sağda boşluk --><organization-invite-member :organization="selected" @closeForm="form()" /></div> </modal>
        <modal id="import-members" :title="$t('workspace.import-users')"> <OrganizationBulkInvite :organization="selected" @onSent="paginate()"/></modal>

        <template v-if="pagination">
          <div class="d-flex justify-content-center my-3">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@c/modal.vue";
import OrganizationBulkInvite from "./organization-bulk-invite.vue";
import OrganizationInviteMember from "./organization-invite-member";
import OrganizationMemberDeleteOptionModal from "./organization-member-delete-option-modal";
import MemberForm from "./organization-member-form";

export default {
  components: { MemberForm, OrganizationBulkInvite, OrganizationInviteMember, Modal, OrganizationMemberDeleteOptionModal },

  data() {
    return {
      nameFilter: undefined,
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: { accessable: { value: true, isObject: true } },
      },
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["organizationMember/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationMember/isLoading"];
    },
    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
    isUpdating() {
      return this.$store.getters["organization/isUpdating"];
    },
    selected() {
      return this.$store.getters["organization/selected"];
    },
    accessableRoles() {
      return this.$store.getters["user/accessableRoles"] || [];
    },
  },

  methods: {
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        const { data: file } = await this.$store.dispatch(`organizationMember/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    paginate() {
      this.$store.dispatch(`organizationMember/paginateWith`, {
        pagination: this.request,
        organizationId: this.selectedOrganization?._id,
      });
    },

    edit(data) {
      this.$store.commit("organizationMember/editedEntity", data);
    },
    async validate(item) {
      const ac = this.accessableRoles?.map((i) => i._id);
      //Eğer kendisini silmeye çalışıyorsa ve erişemediği bir rol varsa silmesine engel olmuş oluyoruz.
      // Normalde kendisini silmesini izin veriyorduk. Onların istekleri doğrultusunda kendi hesabı üzerinde
      //silme işlemi yaparken bu kontrol disable edilebilir.
      const checkNotAccessableRoles = item?.roles.some((r) => !ac.includes(r._id));

      const checkAdmin = this.currentOrganization?.createdBy?._id == item?.accountId;
      if (checkNotAccessableRoles || checkAdmin) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.forbidden") });
        this.$bvModal.hide(`organization-member-delete-option-modal${item._id}`);
      } else {
        this.$bvModal.show(`organization-member-delete-option-modal${item._id}`);
      }
    },
    async remove(data) {
      try {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
        await this.$store.dispatch(`organizationMember/delete`, data);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.$bvModal.hide(`organization-member-delete-option-modal${data.id}`);
        this.paginate();
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationMember/resetForm");
    },
    form() {
      this.paginate();
      this.$bvModal.hide("invite-member");
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./organization-members.scss");
</style>
